import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { ConfigService } from 'src/app/common/service/app.config.service';
import { AppConfig } from 'src/app/common/model/appconfig';
import { Subscription } from 'rxjs';
import { Globals } from './globals';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import * as $ from 'jquery';
import { BnNgIdleService } from 'bn-ng-idle';
import clevertap from 'clevertap-web-sdk'
import { Platform } from '@ionic/angular';
import { CleverTap } from '@ionic-native/clevertap/ngx';
import { datadogRum } from '@datadog/browser-rum';
import { CommonService } from './common/service/common.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [Idle]
})
export class AppComponent implements OnInit, OnDestroy {
  menuMode = 'static';
  config: AppConfig;
  themeSet;

  title = 'ILOUNGEAOT';
  private idleTIme: Subscription;
  private idletimout: Subscription;
  private idlestart: Subscription;
  private routerOut: Subscription;
  idleState = 'Not started.';
  timedOut = false;

  constructor(private primengConfig: PrimeNGConfig, public configService: ConfigService, private idle: Idle, private router: Router, private globals: Globals,private bnIdle: BnNgIdleService,private platform: Platform, private clevertapApp: CleverTap,private commonService: CommonService) {
    this.commonService.iloungeInit().subscribe((data : any) => {
      let encodedkeys = data.key_iv;
      let decodedKeys = atob(encodedkeys)
      let splitData=decodedKeys.split("~");
      this.globals.PASSWORD = splitData[0];
      this.globals.Key_IV = splitData[1];
      this.globals.SALT = splitData[2];
    });
    this.commonService.vConnectInit().subscribe((data : any) => {
      let encodedkeys = data.key_iv;
      let decodedKeys = atob(encodedkeys)
      let splitData=decodedKeys.split("~");
      this.globals.VCONNECT_SHARED_KEY = splitData[0];
      this.globals.VCONNECT_Key_IV = splitData[1];
    });
    $(window).scroll(function () {
      if ($(this).scrollTop()) {
        $('#backToTop:hidden').stop(true, true).fadeIn();
      } else {
        $('#backToTop').stop(true, true).fadeOut();
      }
    });

    this.bnIdle.startWatching(900).subscribe((res) => {
      if(res) {
          console.log("session expired");
          if(this.globals && this.globals.ILUSERDTO && this.globals.ILUSERDTO.loginId) {
            this.commonService.saveUserActionTrackingDetails("Session Expired",this.globals.ILUSERDTO.loginId).subscribe(data => {});
          }
          sessionStorage.clear();
           window.location.href = window.location.origin+'/'+this.globals.App_Context+'/login?sessionExpirate=true';
      }
    })

    // // sets an idle timeout of 600 seconds, for testing purposes.
    // idle.setIdle(600);
    // // sets a timeout period of 600 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    // idle.setTimeout(600);
    // // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    // idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // this.idleTIme = idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
    // this.idletimout = idle.onTimeout.subscribe(() => {
    //   this.idleState = 'Timed out!';
    //   sessionStorage.clear();
    //   this.timedOut = true;
    //   window.location.href = window.location.origin+'/'+this.globals.App_Context+'/login?sessionExpirate=true';
    //   // this.router.navigate(['/login', { sessionExpirate: 'true' }]);
    // });
    // this.idlestart = idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
    // this.reset();
    // this.routerOut = router.events.subscribe((event) => {
    //   if (event instanceof NavigationStart) {
    //   }
    //   if (event instanceof NavigationEnd) {
    //   }
    //   if (event instanceof NavigationError) {
    //   }
    //   if (event instanceof NavigationCancel) {
    //   }
    // });
    this.globals.ILUSERDTO = JSON.parse(sessionStorage.getItem("currentILUserDTO"));
   this.globals.USER = JSON.parse(sessionStorage.getItem("currentUser"));
  //  this.initialize_DATADOG_RUM();
  }

  cleverTapInit() {
    //clevertap initialization
    if (((this.platform.is('android') || this.platform.is('ios')|| this.platform.is('mobile')) && (this.platform.platforms() && !this.platform.platforms().includes('mobileweb'))) && this.globals.IS_MOBILE_CLEVERTAP_ENABLE) {
      this.platform.ready().then(() => {
        // once the platform is ready and plugins are available,
        // do all higher level native things
        this.clevertapApp.notifyDeviceReady();
        // statusBar.styleDefault();
        // splashScreen.hide();

        document.addEventListener('onCleverTapProfileDidInitialize', (e: any) => {
          console.log('onCleverTapProfileDidInitialize');
          console.log(e.CleverTapID);
        });

        document.addEventListener('onCleverTapInAppNotificationDismissed', (e: any) => {
          console.log('onCleverTapInAppNotificationDismissed');
          console.log(JSON.stringify(e.extras));
          console.log(JSON.stringify(e.actionExtras));
        });

        document.addEventListener('onDeepLink', (e: any) => {
          console.log('onDeepLink');
          console.log(e.deeplink);
        });

        document.addEventListener('onPushNotification', (e: any) => {
          console.log('onPushNotification');
          console.log(JSON.stringify(e.notification));
        });

        document.addEventListener('onCleverTapPushNotificationTappedWithCustomExtras', (e: any) => {
          console.log('onCleverTapPushNotificationTappedWithCustomExtras');
          console.log(JSON.stringify(e.notification));
        });

        this.clevertapApp.setDebugLevel(3);
        this.clevertapApp.enablePersonalization();
        this.clevertapApp.registerPush();

        this.clevertapApp.createNotificationChannel('TEST_CHANNEL', 'Test Channel', 'A TEST channel', 0, true);
        this.clevertapApp.profileGetCleverTapID().then((id) => {
          console.log('CleverTapID: ' + id);
        });
        /*
        clevertap.recordEventWithName('foo');
        clevertap.recordEventWithNameAndProps('boo', {bar: 'zoo'});
        clevertap.recordScreenView('Home');
        clevertap.recordChargedEventWithDetailsAndItems({amount: 300, 'Charged ID': 1234}, [{
          Category: 'Books',
          Quantity: 1,
          Title: 'Book Title'
        }]);
         */
        this.clevertapApp.eventGetFirstTime('Cordova Event 1').then((time) => {
          console.log('CE1 event first time is ' + time);
        });
        this.clevertapApp.eventGetLastTime('App Launched').then((time) => {
          console.log('app launched last time is ' + time);
        });
        this.clevertapApp.eventGetOccurrences('foo').then((num) => {
          console.log('foo event occurrences ' + num);
        });
        this.clevertapApp.eventGetDetails('Charged').then((res) => {
          console.log(JSON.stringify(res));
        });
        this.clevertapApp.getEventHistory().then((history) => {
          console.log(JSON.stringify(history));
        });
        this.clevertapApp.eventGetFirstTime('noevent').then((time) => {
          console.log('noevent event first time is ' + time);
        });
        this.clevertapApp.eventGetLastTime('noevent').then((time) => {
          console.log('noevent last time is ' + time);
        });
        this.clevertapApp.eventGetOccurrences('noevent').then((num) => {
          console.log('noevent occurrences ' + num);
        });
        this.clevertapApp.eventGetDetails('noevent').then((res) => {
          console.log(JSON.stringify(res));
        });
        // this.clevertapApp.onUserLogin({Identity: 'android098768', custom: 122211});
        // this.clevertapApp.profileSet({Identity: 'a12345678', custom12: 1.311});
        this.clevertapApp.profileGetProperty('Identity').then((val) => {
          console.log('Identity profile value is ' + val);
        });
        this.clevertapApp.profileGetProperty('custom').then((val) => {
          console.log('custom profile value is ' + val);
        });
        this.clevertapApp.sessionGetTimeElapsed().then((val) => {
          console.log('session elapsed time is ' + val);
        });
        this.clevertapApp.sessionGetTotalVisits().then((val) => {
          console.log('session total visits is ' + val);
        });
        this.clevertapApp.sessionGetScreenCount().then((val) => {
          console.log('session screen count is ' + val);
        });
        this.clevertapApp.sessionGetPreviousVisitTime().then((val) => {
          console.log('session previous visit time is ' + val);
        });
        this.clevertapApp.sessionGetUTMDetails().then((val) => {
          console.log(JSON.stringify(val));
        });
      });
      this.clevertapApp.setDebugLevel(3)
    } else {
      clevertap.privacy.push({ optOut: false });
      clevertap.privacy.push({ useIP: true });
      clevertap.init('TEST-589-9W4-RR7Z', 'in1'); //R59-KK5-996Z
    }
  }

  onDeviceReady() {
    this.clevertapApp.notifyDeviceReady();
    console.log('CleverTap Device is Ready');
  }
  ngOnInit() {
    this.primengConfig.ripple = true;
    document.documentElement.style.fontSize = '14px';



    if (!sessionStorage.getItem('theme')) {
      sessionStorage.setItem('theme', JSON.stringify({ theme: 'rs-theme', dark: false }));
      this.themeSet = JSON.parse(sessionStorage.getItem('theme'));
      this.changeTheme(this.themeSet.theme, this.themeSet.dark);
    } else {
      this.themeSet = JSON.parse(sessionStorage.getItem('theme'));
      this.changeTheme(this.themeSet.theme, this.themeSet.dark);
    }
    this.cleverTapInit();
  }

  changeTheme(theme: string, dark: boolean) {
    let themeElement = document.getElementById('theme-css');
    themeElement.setAttribute('href', 'assets/theme/' + theme + '/theme.css');
    this.configService.updateConfig({ ...this.config, ...{ theme, dark } });
  }

  scrollToTop() {
    window.scrollTo(0, 0);
    this.callAutoLogin();
  }

  // reset() {
  //   this.idle.watch();
  //   this.idleState = 'Started.';
  //   this.timedOut = false;
  // }

  ngOnDestroy() {
    if (this.routerOut) {
      this.routerOut.unsubscribe();
    }
    if (this.idleTIme) {
      this.idleTIme.unsubscribe();
    }
    if (this.idletimout) {
      this.idletimout.unsubscribe();
    }
    if (this.idlestart) {
      this.idlestart.unsubscribe();
    }
  }

  callAutoLogin() {
    var form = document.createElement("form");
    var element1 = document.createElement("input");
    var element2 = document.createElement("input");

    form.method = "POST";
    form.action = this.globals.BACKEND_URL_PREFIX + 'iLounge/doautologin';

    element1.value = "AG002057";
    element1.name = "userName";
    form.appendChild(element1);

    element2.value = "Feb@2021";
    element2.name = "pwd";;
    form.appendChild(element2);

    document.body.appendChild(form);
    form.submit();
  }

  initialize_DATADOG_RUM() {
    // console.log(this.globals.RUM_DATADOG);
  // Initialize DataDog RUM
  var payload: any = {
    clientToken: this.globals.RUM_DATADOG.CLIENT_TOKEN,
    applicationId: this.globals.RUM_DATADOG.APPLICATION_ID,
    site: this.globals.RUM_DATADOG.SITE,
    service: this.globals.RUM_DATADOG.SERVICE,
    env: this.globals.RUM_DATADOG.ENV,
    allowedTracingUrls: this.globals.RUM_DATADOG.ALLOWED_URLS,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: this.globals.RUM_DATADOG.PRIVACY_LEVEL,
  };
  datadogRum.init(payload);
  
    // Set DataDog RUM User Session
    this.setRumUserSession();
  }

  setRumUserSession() {
    if(this.globals.ILUSERDTO) {
      var USER_ID = this.globals.ILUSERDTO.loginId;
      var USERNAME = this.globals.ILUSERDTO.userName;
      var PREMIUM = "premium";
      var EMAIL = this.globals.ILUSERDTO.emailId;
      datadogRum.setUser({ id: USER_ID, name: USERNAME, email: EMAIL, plan: PREMIUM });
    }
  }
}
